import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@org/ui';
import { Plus, MessageSquare, BarChart3 } from 'lucide-react';

interface FloatingCreateButtonProps {
  spaceId?: string;
}

export function FloatingCreateButton({ spaceId }: FloatingCreateButtonProps) {
  const { t } = useTranslation('community');

  return (
    <div className="fixed bottom-20 right-4 z-40 md:hidden">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            size="icon"
            className="h-14 w-14 rounded-full shadow-lg"
            aria-label={t('fab.newPost')}
          >
            <Plus className="h-6 w-6" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" side="top" className="mb-2">
          <DropdownMenuItem asChild>
            <Link
              to="/posts/new"
              search={{ type: 'discussion' as const, ...(spaceId ? { spaceId } : {}) }}
            >
              <MessageSquare className="mr-2 h-4 w-4" />
              {t('fab.newDiscussion')}
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link
              to="/posts/new"
              search={{ type: 'poll' as const, ...(spaceId ? { spaceId } : {}) }}
            >
              <BarChart3 className="mr-2 h-4 w-4" />
              {t('fab.newPoll')}
            </Link>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
